import { render, staticRenderFns } from "./TabOptions.vue?vue&type=template&id=2ee5ba0e&scoped=true&"
import script from "./TabOptions.vue?vue&type=script&lang=js&"
export * from "./TabOptions.vue?vue&type=script&lang=js&"
import style0 from "./TabOptions.vue?vue&type=style&index=0&id=2ee5ba0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee5ba0e",
  null
  
)

export default component.exports